<template>
	<div class="c-page-hero">
		<div class="bg-primary print:bg-transparent text-text">
			<div class="c-page-hero__main relative flex flex-col >=1024:block">
				<!-- Content -->
				<div
					:class="[
						'c-page-hero__content flex-1',
						'c-page-hero__content--image >=1024:w-1/2',
						'pt-layout-margin pl-layout-margin pr-layout-margin',

						{
							'pb-md >=1024:pb-md2': image || !slim,
							'pb-md2': !image && !slim,
							'pb-md2': slim && $scopedSlots.after,
						},
					]"
				>
					<!-- Breadcrumb -->
					<PageBreadcrumb
						v-if="breadcrumb"
						:data="breadcrumb"
						class="mb-md print:hidden"
					/>

					<!-- Content -->
					<BaseH1
						:class="{ '>=1024:w-6/12': !image }"
						v-html="title"
					/>

					<div
						v-if="description && description.length"
						:class="['text-h3 mt-sm', { '>=1024:w-6/12': !image }]"
						v-html="description"
					></div>
				</div>

				<!-- Image -->
				<div
					v-if="image"
					:class="[
						'c-page-hero__image',
						'relative w-full bg-primary-medium h-0',
						'>=1024:absolute >=1024:top-0 >=1024:right-0',
						'>=1024:h-full >=1024:flex-1 >=1024:w-1/2',
					]"
				>
					<UmbracoImageExt
						v-if="image"
						:alt="image.altText"
						:widths="[
							320,
							480,
							720,
							960,
							1200,
							1440,
							1920,
							1200 * 2,
							1440 * 2,
							1920 * 2,
						]"
						:source-url="image.cropUrl || image.url"
						:source-width="image.width"
						:source-height="image.height"
						:aspect-ratio="1.6"
						image-class-names="object-cover"
						:class="[
							'absolute w-full h-full',
							'bg-primary-medium >=1024:relative',
						]"
					/>
				</div>

				<!-- Fallback SVG -->

				<SvgBridgeIcon
					v-if="!image && !noFallbackImage"
					class="text-primary-light"
					:class="[
						'relative w-full bg-primary h-0',
						'>=1024:absolute >=1024:bottom-0 >=1024:right-0',
						'>=1024:w-1/2 >=1024:max-h-full >=1024:h-auto',
					]"
				/>
			</div>

			<div
				v-if="$scopedSlots.after"
				:class="[
					'px-layout-margin pb-xl print:pb-0',
					{ 'pt-lg': !slim, 'pt-0': slim },
				]"
			>
				<slot name="after"></slot>
			</div>
		</div>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/shared/UmbracoImageExt.vue';
import SvgBridgeIcon from '~/assets/svgs/bridge-icon.svg?inline';
import PageBreadcrumb from '~/components/shared/PageBreadcrumb';

export default {
	name: 'PageHero',
	components: {
		UmbracoImageExt,
		PageBreadcrumb,
		SvgBridgeIcon,
	},

	props: {
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: false,
		},
		image: {
			type: Object,
			required: false,
		},
		noFallbackImage: {
			type: Boolean,
			default: false,
		},
		breadcrumb: {
			type: Array,
			required: false,
		},
		slim: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		computedAnchor() {
			const query = (this.image.cropUrl || this.image.url).split('?')[1];

			if (query) {
				const map = query.split('&').map((e) => e.split('='));
				const rxy = map.find((e) => e[0] === 'rxy')[1];
				const r = rxy.split(',').map((e) => `${parseFloat(e) * 100}%`);
				return r.join(' ');
			}

			return '';
		},
	},
};
</script>

<style lang="postcss">
/**
	Forces primary background on text,
	because SiteImprove is weird.
 */
.c-page-hero .c-page-hero__main,
.c-page-hero .c-page-hero__main * {
	background-color: var(--color-primary) !important;
}

.c-page-hero__image {
	padding-bottom: calc((6 / 7) * 100%);
}

@screen >=1024 {
	.c-page-hero__image {
		padding-bottom: 0;
	}
}

/* .c-page-hero__image .c-umbraco-image-ext img {
	object-fit: none !important;
} */

/* For proper spacing */
.c-page-hero__content {
	padding-top: 144px !important;
	padding-top: calc(
		144px - var(--theme-spacing-xl--sm) +
			var(--theme-spacing-xl, var(--theme-spacing-xl--sm))
	) !important;
}

@screen >=1024 {
	.c-page-hero__content {
		padding-top: 186px !important;
		padding-top: calc(
			186px - var(--theme-spacing-xl--md) +
				var(--theme-spacing-xl, var(--theme-spacing-xl--sm))
		) !important;
	}
}

@screen >=1440 {
	.c-page-hero__content {
		padding-top: 232px !important;
		padding-top: calc(
			232px - var(--theme-spacing-xl--md) +
				var(--theme-spacing-xl, var(--theme-spacing-xl--sm))
		) !important;
	}
}

@screen print {
	.c-page-hero__content {
		padding-top: 0 !important;
	}
	.c-page-hero .c-page-hero__main,
	.c-page-hero .c-page-hero__main * {
		background-color: transparent !important;
	}
}
</style>
